var map = {
	"./Cards/index.ts": 9514,
	"./Lefty/index.ts": 69753,
	"./NiftyFifty/index.ts": 56687,
	"./Panels/index.ts": 65433,
	"./SimpleBlog/index.ts": 50841,
	"./Townhall/index.ts": 99419
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 23799;